export default __webpack_public_path__ + "static/media/Picture4.4742bb73.png";